import type { ReactNode } from "react";
import { useSchoolLocal } from "../useSchoolLocal";

type SectionTitleProps = {
  children: ReactNode;
  className?: string;
};

export const SectionTitle = ({
  children,
  className = "",
}: SectionTitleProps) => {
  const { headingFont } = useSchoolLocal();

  return (
    <h2
      className={`text-2xl font-bold leading-tight md:text-[32px] ${headingFont} ${className}`}
    >
      {children}
    </h2>
  );
};
